import React from 'react'
import { InternalIconProps } from '../Icon.types'

const Pricing = ({
  colors: { primary, secondary },
  ...props
}: InternalIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill={secondary}
      d="M17.974 2.417l4.242 4.242-2.121 2.122 2.828 2.828 2.122-2.121 4.242 4.242-4.95 4.95L13.025 7.367l4.95-4.95z"
    />
    <path
      fill={primary}
      fillRule="evenodd"
      d="M6.66 23.63l-5.657-5.657L17.971 1l5.66 5.66-1.415 1.414c-.39.39-.39 1.023 0 1.414.39.39 1.024.39 1.415 0l1.414-1.414 5.654 5.654-16.97 16.97-5.655-5.654 2.122-2.121c.39-.39.39-1.024 0-1.414-.39-.39-1.024-.39-1.415 0l-2.12 2.121zM20.802 6.66l-2.83-2.832L3.828 17.971 6.66 20.8l.707-.706c1.172-1.172 3.071-1.172 4.243 0 1.171 1.171 1.171 3.07 0 4.242l-.707.707 2.825 2.826 14.143-14.142-2.826-2.826c-1.172 1.172-3.071 1.172-4.243 0-1.171-1.171-1.171-3.071 0-4.243zm-3.535 3.535l-1.415-1.414-1.414 1.414 1.414 1.414 1.415-1.414zm4.242 4.243l1.415 1.414-1.415 1.414-1.414-1.414 1.414-1.414zm-1.414-1.415L18.68 11.61l-1.415 1.414 1.415 1.415 1.414-1.415z"
      clipRule="evenodd"
    />
  </svg>
)

export default Pricing
